<div class="token-refresh-modal" data-testid="token-refresh-overlay">
  <div class="token-refresh-modal__card">
    <p class="token-refresh-modal__title" data-testid="modal-message">
      {{ 'TOKEN_REFRESH_MODAL.TITLE' | translate }}
    </p>

    <p class="token-refresh-modal__subtitle" data-testid="modal-submessage">
      {{ 'TOKEN_REFRESH_MODAL.AUTO_REDIRECT_MESSAGE' | translate }}
    </p>
  </div>
</div>
